var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"element":"shop-item"}},[_c('el-tooltip',{staticClass:"shop-tooltip",attrs:{"effect":"dark","content":_vm._shop.name,"placement":"top"}},[_c('el-image',{attrs:{"src":_vm._shop.icon?_vm._shop.icon:_vm._shop.logo_url}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }